module.exports = __webpack_public_path__ + "img/03.c6e3e839.jpg";